import config from 'services/table/const';
import Action from './action';
import ItemsStatus from './status';

let table = { ...config };
table.url = '/product';
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    alias: 'code',
    width: 80,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold">{row?.code}</div>
        </div>
      );
    },
  },

  name: {
    title: 'Nama',
    sortable: true,
    alias: 'name',
    width: 150,
    component: (row) => {
      return <div className="text-ellipsis">{row?.name || '-'}</div>;
    },
  },

  category: {
    title: 'Kategori',
    sortable: true,
    alias: 'category',
    width: 80,
    component: (row) => {
      return <div className="text-ellipsis">{row?.category}</div>;
    },
  },

  unit_default: {
    title: 'Unit',
    sortable: true,
    alias: 'unit_default',
    width: 80,
    component: (row) => {
      return <div>{row?.unit_default}</div>;
    },
  },

  is_active: {
    title: 'Status',
    sortable: true,
    format_number: false,
    class: 'text-center',
    classHeader: 'text-center',
    width: 70,
    component: (row) => {
      return <ItemsStatus data={row} />;
    },
  },

  action: {
    title: '',
    sortable: false,
    width: 40,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
